module.exports = __webpack_public_path__ + "assets/cd52f1919ec3c60aa4038e10bb207aa9.svg";